import React from "react";
import "./FormGroup.css";

// FormGroup — wrapper de champ partagé (label + contrôle).
// Marquage OBLIGATOIRE unifié (même règle que Input/Select/Calendar/TimeSelect) : affiche UN SEUL
// astérisque rouge stylé quand `required` est vrai OU quand le libellé le porte déjà, en évitant
// le double astérisque. L'astérisque reflète l'état obligatoire RÉEL (prop `required`), il ne
// remplace jamais le libellé. `htmlFor` relie le label au contrôle quand il est fourni.
const FormGroup = ({ label, required = false, htmlFor, children }) => {
  // Retire un éventuel « * » final déjà présent dans le libellé (dé-duplication).
  const cleanLabel = typeof label === 'string' ? label.replace(/\s*\*\s*$/, '') : label;
  const showStar = required || (typeof label === 'string' && /\*\s*$/.test(label));
  return (
    <div className="form-group">
      {label && (
        <label className="form-label" htmlFor={htmlFor}>
          {cleanLabel}
          {showStar && <span className="required" aria-hidden="true"> *</span>}
        </label>
      )}
      {children}
    </div>
  );
};

export default FormGroup;
